import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { CnpjPipe } from '../shared/pipe/cnpj-pipe';
import { CpfPipe } from '../shared/pipe/cpf-pipe';
import { FormateNumberZeroPipe } from '../shared/pipe/format-number-zero.pipe';
import { MatriculaPipe } from '../shared/pipe/matricula.pipe';
import { MesPipe } from '../shared/pipe/mes.pipe';
import { MesesPipe } from '../shared/pipe/meses.pipe';
import { DRMaiorOrIgual2012Pdf } from '../shared/services/documentos-pdf-imprimir/Plano/destinacao-reserva/drMaiorOrIgual2012-pdf';
import { DocumentosService } from '../shared/services/documentos.service';
import { PessoaService } from '../shared/services/pessoa.service';
import { DateUtilService } from '../shared/util/date-util.service';
import { AreaRestritaSharedModule } from './../shared/area-restitra.shared.module';
import { BeneficioProporcionalDiferidoModule } from './beneficio-proporcional-diferido/beneficio-proporcional-diferido.module';
import { FpcModule } from './fpc/fpc.module';
import { PcdDemosntrativoComponent } from './pcd-demosntrativo/pcd-demosntrativo.component';
import { PbdcModule } from './plano/pbdc.module';
import { PlanosRoutingModule } from './router/planos.router';
import { PlanosService } from './service/planos.service';
import { PcdDashboardComponent } from './pcd-dashboard/pcd-dashboard.component';
import { PbbPainelControleGerencialComponent } from './pbb-painel-controle-gerencial/pbb-painel-controle-gerencial.component';
import { PcdInformacoesComponent } from './pcd-informacoes/pcd-informacoes.component';

@NgModule({
    imports: [
        CommonModule,
        AreaRestritaSharedModule,
        PlanosRoutingModule,
        BeneficioProporcionalDiferidoModule,
        FpcModule,
        PbdcModule

    ],
    declarations: [
        PcdDemosntrativoComponent,
        PcdDashboardComponent,
        PbbPainelControleGerencialComponent,
        PcdInformacoesComponent
    ],
    providers: [
        PlanosService,
        DecimalPipe,
        FormateNumberZeroPipe,
        CnpjPipe,
        CpfPipe,
        MatriculaPipe,
        MesPipe,
        MesesPipe,
        DatePipe,
        PessoaService,
        DateUtilService,
        DRMaiorOrIgual2012Pdf,
        DocumentosService
    ]
})
export class PlanosModule {
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/planos.module.ts